(() => {
  const initSpecs = (root) => {
    if (!root || root.dataset.specsReady === 'true') return;
    const table = root.querySelector('[data-specs-matrix]');
    if (!table) return;
    root.dataset.specsReady = 'true';

    const setActiveColumn = (variantId, behavior = 'smooth') => {
      const id = String(variantId);
      table.querySelectorAll('[data-variant-col]').forEach((cell) => {
        cell.classList.toggle('cd13-specs__col--active', cell.dataset.variantCol === id);
      });

      const scrollArea = table.closest('.cd13-specs__scroll');
      const selectedHeader = table.querySelector(`thead [data-variant-col="${id}"]`);
      if (!scrollArea || !selectedHeader) return;

      window.requestAnimationFrame(() => {
        const preferredLeft = selectedHeader.offsetLeft
          - ((scrollArea.clientWidth - selectedHeader.offsetWidth) / 2);
        const left = Math.max(0, Math.min(preferredLeft, scrollArea.scrollWidth - scrollArea.clientWidth));
        scrollArea.scrollTo({ left, behavior });
      });
    };

    const productRoot = root.closest('[data-product-root]') || document;
    const idInput = productRoot.querySelector('[data-variant-id-input]');
    const optionGroups = [...productRoot.querySelectorAll('[data-option-position]')]
      .sort((first, second) => Number(first.dataset.optionPosition) - Number(second.dataset.optionPosition));

    const currentVariantId = () => {
      if (optionGroups.length === 0) return idInput?.value;
      const variantsJson = productRoot.querySelector('[data-product-variants-json]');
      if (!variantsJson) return idInput?.value;
      let variants = [];
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (error) {
        return idInput?.value;
      }
      const options = optionGroups.map((group) => group.querySelector('[data-option-value]:checked')?.value || '');
      const match = variants.find((item) => item.options.every((value, index) => value === options[index]));
      return match ? match.id : idInput?.value;
    };

    optionGroups.forEach((group) => {
      group.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-value]')) {
          const id = currentVariantId();
          if (id) setActiveColumn(id, 'smooth');
        }
      });
    });

    productRoot.addEventListener('cd13:variant-change', (event) => {
      const variantId = event.detail?.variant?.id;
      if (variantId) setActiveColumn(variantId, 'smooth');
    });

    const initialId = currentVariantId();
    if (initialId) setActiveColumn(initialId, 'auto');
  };

  const init = (scope = document) => {
    const roots = scope.matches?.('[data-specs-root]') ? [scope] : scope.querySelectorAll('[data-specs-root]');
    roots.forEach(initSpecs);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
